const dumm_expenses = [
    {
        id: 1,
        title: 'Car Insurance',
        amount: 15.0,
        date: new Date(2022, 1, 13),
    },
    {
        id: 2,
        title: 'House Insurance',
        amount: 20.0,
        date: new Date(2020, 2, 15),
    },
    {
        id: 3,
        title: 'Person Insurance',
        amount: 35.0,
        date: new Date(2021, 3, 16),
    },
    {
        id: 4,
        title: 'Money Insurance',
        amount: 50.0,
        date: new Date(2021, 4, 17),
    },
    {
        id: 5,
        title: 'lala Insurance',
        amount: 10.0,
        date: new Date(2022, 5, 18),
    },
];

export default dumm_expenses;
